
export { default as HomeInfo } from "./HomeInfo"